// extracted by mini-css-extract-plugin
export default {"wrapper":"ISMda6","select":"mLYoXG","arrow-down":"z9w579","arrowDown":"z9w579","ltr":"P3B6gV","rtl":"z_0LKu"};